"use client";

import "../globals.css";
import { Footer, Layout, Navbar } from "@/features/Home/components";
import { notoSansThaiFonts } from "../fonts";
import { Suspense, useState } from "react";
import QueryUpdater from "@/components/QueryUpdater";
import { ChatBubbleOvalLeftEllipsisIcon } from "@heroicons/react/24/solid";
import { DialogContactStaff } from "@/components/DialogContactStaff";
import CookieButton from "@/components/CookieButton";
import Script from "next/script";

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const [openDialog, setOpenDialog] = useState(false);

  return (
    <html lang="th">
      <head>
        <link rel="shortcut icon" href="/favicon.png" type="image/png" />
      </head>

      <body
        className={`${notoSansThaiFonts.className} flex flex-col min-h-screen`}
      >
        <Suspense fallback={null}>
          <QueryUpdater />
        </Suspense>
        <Layout>
          <a
            href="#main-content"
            className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 bg-[#126d37] text-white px-4 py-2 rounded-md z-50"
          >
            ข้ามไปยังเนื้อหาหลัก
          </a>
          <Navbar />
          <DialogContactStaff isOpen={openDialog} onClose={setOpenDialog} />
          <main id="main-content" className="flex-grow pt-28 md:pt-8">
            {children}
          </main>
          <button
            name="contact-staff"
            className="bottom-2 right-8 z-10 fixed bg-[#188F46] w-16 h-16 rounded-full hover:bg-[#126d37] transition-colors duration-300 focus:outline-none focus:ring-4 focus:ring-[#188F46]/50"
            onClick={() => setOpenDialog(true)}
            aria-label="ติดต่อเจ้าหน้าที่"
          >
            <span className="sr-only">ติดต่อเจ้าหน้าที่</span>
            <div className="flex justify-center items-center h-full">
              <ChatBubbleOvalLeftEllipsisIcon color="white" width={28} />
            </div>
          </button>

          <CookieButton />

          <Footer />
        </Layout>
        <Script
          src="https://api.nepcha.com/js/nepcha-analytics.js"
          strategy="afterInteractive"
          data-site="agentsrikrung.com"
        />
        {/* </CookieManager> */}
      </body>
    </html>
  );
}
